import { millisecondsPer } from '@art-suite/art-core-ts';
export const DEFAULT_PRIORITY = 0;
export const DEFAULT_STALE_AGE_MS = 1000;
export const DEFAULT_MAX_AGE_MS = 7 * millisecondsPer.day;
export const DEFAULT_RETRY_DELAY_MS = 500;
export const DEFAULT_BACKOFF_FACTOR = 1.5;
export const DEFAULT_MAX_CONCURRENT_REQUESTS = 20;
export const DEFAULT_MAX_RETRY_MS = 5 * millisecondsPer.minute;
export const DEFAULT_MAX_RETRY_DELAY_MS = 30 * millisecondsPer.second;
